import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, LangChangeEvent, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';
import { CommonModule } from '@angular/common';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { HttpService } from '../../../services/http.service';

@Component({
  selector: 'app-specialist-categorization-selection',
  standalone: true,
  imports: [CommonModule, NzDividerModule, NzRadioModule, ReactiveFormsModule, TranslateModule, InfoBoxComponent],
  templateUrl: './specialist-categorization-selection.component.html',
  styleUrls: ['./specialist-categorization-selection.component.scss'],
})
export class SpecialistCategorizationSelectionComponent implements OnInit, OnDestroy {
  @Output() specialistEmitter: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  radioForm?: FormGroup;
  subscriptions: Array<Subscription> = [];
  radioLabels!: { id: string; description: string }[];

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private appointmentStepperService: AppointmentStepperService,
    private http: HttpService
  ) {}

  public ngOnInit(): void {
    this.getSpecialist();
    this.radioForm = this.fb.group({});
    this.radioForm?.addControl('specialistType', new FormControl('', Validators.required));
    this.emitSpecialistForm();
    const oldValues = this.appointmentStepperService.getSpecialistData();
    if (oldValues) {
      this.specialistEmitter.emit(this.radioForm as FormGroup);
    }
  }

  private getSpecialist(): void {
    this.subscriptions.push(
      this.http.specialistByLanguage().subscribe((specialist: { id: string; description: string }[]) => {
        this.radioLabels = specialist;
      })
    );
  }

  private emitSpecialistForm(): void {
    if (this.radioForm) {
      this.subscriptions.push(
        this.radioForm.valueChanges.subscribe((_): void => {
          this.specialistEmitter.emit(this.radioForm as FormGroup);
        })
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }
}
